import React, { useState, useEffect } from "react";
import Header from "../components/navBar";
import HeroSection from "../components/home/hero";
import FeaturedItems from "../components/home/featured_items";
import CategoryItems from "../components/home/category";
import AdSection from "../components/home/adSection";
import Footer from "../components/footer"
import Faq from "../components/home/FAQ";
import Discounted from "../components/home/discounted";
import SectionWrapper from "../common/inviewWrapper";

const HomePage = () => {

  return (
<section>
      <Header />
      <SectionWrapper>
        <HeroSection />
      </SectionWrapper>
      <SectionWrapper>
        <FeaturedItems />
      </SectionWrapper>
      <SectionWrapper>
        <Discounted />
      </SectionWrapper>
      <SectionWrapper>
        <CategoryItems />
      </SectionWrapper>
      <SectionWrapper>
        <AdSection />
      </SectionWrapper>
      <SectionWrapper>
        <Faq />
      </SectionWrapper>
      <Footer />
    </section>
  );
};

export default HomePage;